module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/point-2-55aa39df2023ec85631c4d9e9a612ff6.png";